<template>
  <CRow>
    <CCol sm="6" lg="3">
      <router-link to="/users">
        <CWidgetDropdown color="primary" :header="'' + users" text="Users">
          <template #footer>
            <CChartLineSimple
              pointed
              class="mt-3 mx-3"
              style="height: 70px"
              :data-points="users_month"
              point-hover-background-color="primary"
              label="Users"
              labels="months"
            />
          </template>
        </CWidgetDropdown>
      </router-link>
    </CCol>
    <CCol sm="6" lg="3">
      <router-link to="/businesses">
        <CWidgetDropdown color="info" :header="'' + businesses" text="Business">
          <template #footer>
            <CChartLineSimple
              pointed
              class="mt-3 mx-3"
              style="height: 70px"
              :data-points="businesses_month"
              point-hover-background-color="info"
              :options="{ elements: { line: { tension: 0.00001 } } }"
              label="Business"
              labels="months"
            />
          </template>
        </CWidgetDropdown>
      </router-link>
    </CCol>
    <CCol sm="6" lg="3">
      <router-link to="/customers">
        <CWidgetDropdown
          color="danger"
          :header="'' + customers"
          text="Customers"
        >
          <template #footer>
            <CChartBarSimple
              class="mt-3 mx-3"
              style="height: 70px"
              background-color="rgb(250, 152, 152)"
              :data-points="entries_month"
              label="Transactions"
              labels="months"
            />
          </template>
        </CWidgetDropdown>
      </router-link>
    </CCol>
    <CCol sm="6" lg="3">
      <router-link to="/entries">
        <CWidgetDropdown color="warning" :header="'' + entries" text="Entries">
          <template #footer>
            <CChartLineSimple
              class="mt-3"
              style="height: 70px"
              background-color="rgba(255,255,255,.2)"
              :data-points="customers_month"
              :options="{ elements: { line: { borderWidth: 2.5 } } }"
              point-hover-background-color="warning"
              label="Customers"
              labels="months"
            />
          </template>
        </CWidgetDropdown>
      </router-link>
    </CCol>
  </CRow>
</template>

<script>
import { CChartLineSimple, CChartBarSimple } from "../charts/index.js";
import firebase from "firebase";
export default {
  name: "WidgetsDropdown",
  components: { CChartLineSimple, CChartBarSimple },
  data() {
    return {
      users: "----",
      users_month: [],
      businesses: "----",
      businesses_month: [],
      customers: "----",
      customers_month: [],
      entries: "----",
      entries_month: [],
    };
  },
  created: function () {
    var db = firebase.firestore();
    db.collection("_counts")
      .doc("users")
      .get()
      .then((querySnapshot) => {
        this.users = querySnapshot.data().data_count;
      });
    db.collection("_counts")
      .doc("business")
      .get()
      .then((querySnapshot) => {
        this.businesses = querySnapshot.data().data_count;
      });
    db.collection("_counts")
      .doc("customer")
      .get()
      .then((querySnapshot) => {
        this.customers = querySnapshot.data().data_count;
      });
    db.collection("_counts")
      .doc("entry")
      .get()
      .then((querySnapshot) => {
        this.entries = querySnapshot.data().data_count;
      });
  },
};
</script>
<style>
a {
  text-decoration: none;
}
</style>
